import { isSamePosition } from '@wareena/game-algorithms';
export default function sortPositionsByTerrainPreferences(positions, mapHexes, terrainPreferences) {
    const sortedPositions = [...positions];
    sortedPositions.sort((a, b) => {
        const hexes = mapHexes.filter((h) => isSamePosition(h, a) || isSamePosition(h, b));
        let hexA = hexes[0];
        let hexB = hexes[1];
        if (isSamePosition(a, hexes[1])) {
            hexA = hexes[1];
            hexB = hexes[0];
        }
        let terrainAIdx = terrainPreferences.findIndex((t) => t === hexA.terrainId);
        let terrainBIdx = terrainPreferences.findIndex((t) => t === hexB.terrainId);
        if (terrainAIdx < 0) {
            terrainAIdx = 1_000_000;
        }
        if (terrainBIdx < 0) {
            terrainBIdx = 1_000_000;
        }
        return terrainAIdx - terrainBIdx;
    });
    return sortedPositions;
}
